<!--
 * @Descripttion: icon组件
 * @Author: 汪佳彪
 * @date: 2021-10-09 10:37
-->
<template>
  <i :class="iconClass" @click="handleClick"></i>
</template>

<script>
  export default {
    name: 'IonIcon',
    props: {
      name: {
        type: String,
      },
      // 前缀
      prefix: {
        type: String,
        default: 'ion-icon-',
      },
    },
    computed: {
      iconClass() {
        const { prefix, name } = this;
        return name ? `${prefix}${name}` : '';
      },
    },
    methods: {
      /**
       * @description 点击事件处理
       */
      handleClick(event) {
        if (this.name) {
          this.$emit('click', event);
        }
      },
    },
  };
</script>

<style lang="scss">
  @import './prod.css';
</style>
